"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimChargerControlDeratingReasonStateValidation = void 0;
const PowerQualityIssueValidation_1 = require("./PowerQualityIssueValidation");
class SimChargerControlDeratingReasonStateValidation {
    static isValid(entity) {
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        // Validate entity.power_quality_issue for existence and correct type.
        if (entity.power_quality_issue == undefined)
            return false;
        if (!PowerQualityIssueValidation_1.PowerQualityIssueValidation.isValid(entity.power_quality_issue))
            return false;
        return true;
    }
}
exports.SimChargerControlDeratingReasonStateValidation = SimChargerControlDeratingReasonStateValidation;
